import { graphql } from 'react-relay';

import { PromotionWindowPaginator_query$key } from '../../../relay/__generated__/PromotionWindowPaginator_query.graphql';
import FragmentWindowPaginator, { FragmentWindowPaginatorProps } from '../../core/FragmentWindowPaginator';
import Pagination from '../../page/Pagination';

const PromotionWindowPaginator_query = graphql`
  fragment PromotionWindowPaginator_query on Query
  @argumentDefinitions(
    filters: { type: PromotionFilter }
    order: { type: PromotionOrder }
    page: { type: Int, defaultValue: 1 }
    pageSize: { type: Int, defaultValue: 20 }
  )
  @refetchable(queryName: "PromotionWindowPaginatorRefreshQuery") {
    promotions(filters: $filters, order: $order, page: $page, pageSize: $pageSize) {
      totalCount
      pages {
        ...Pagination_pages
      }
      edges {
        node {
          id
        }
      }
      ...PromotionConnectionDataTable_promotionConnection
    }
  }
`;

type Props = {} & Omit<FragmentWindowPaginatorProps<PromotionWindowPaginator_query$key>, 'fragment'>;

const PromotionWindowPaginator = ({ ...props }: Props) => (
  <FragmentWindowPaginator fragment={PromotionWindowPaginator_query} {...props}>
    {(data, { loadPage }) =>
      props.children(data, {
        loadPage,
        renderPagination: (props) => <Pagination {...props} pages={data.promotions.pages} loadPage={loadPage} />,
      })
    }
  </FragmentWindowPaginator>
);

export default PromotionWindowPaginator;
